import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Box from '@mui/material/Box'
import LinearProgress from '@mui/material/LinearProgress'
import { useTheme } from '@mui/material/styles'
import React from 'react'

import NotificationBadgeCircle from './NotificationBadgeCircle'
import { BELL_BADGE_SIZE } from './notificationCenterConstants'
import NotificationSummary from './NotificationSummary'

type NotificationPendingToastProps = {
  title: string
  description?: string
  /** False once the run stopped reporting: the bar goes, the toast stays long enough to read. */
  isWaiting?: boolean
}

/**
 * A run accepted but not yet reported — the same summary as the toast it turns into, so resolving reads
 * as one toast changing. Info, not success, because only the request succeeded; a bar, not a spinner,
 * because the run publishes no progress; and no timestamp, because nothing has occurred yet.
 */
const NotificationPendingToast = ({ title, description, isWaiting = true }: NotificationPendingToastProps) => {
  const theme = useTheme()

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <NotificationSummary
        badge={
          <NotificationBadgeCircle color={theme.palette.info.main} size={BELL_BADGE_SIZE}>
            <InfoOutlinedIcon fontSize="small" />
          </NotificationBadgeCircle>
        }
        description={description}
        title={title}
      />
      {/* Flush to the toast's bottom edge, the way a grid or a page-level refetch shows one. */}
      {isWaiting && <LinearProgress color="info" sx={{ position: 'absolute', bottom: 0, left: 0, right: 0 }} />}
    </Box>
  )
}

export default NotificationPendingToast
